import { API } from 'aws-amplify'
import PlaceCache from './PlaceCache'
import NadheoPlaceSeats from '../NadheoPlaceSeats'

export default class PerformanceCache {
  // PerformanceRef -> Performance (returned by retrieve)
  static performances = new Map([]);
  // PerformanceRef -> PerformanceSeats (return by
  static performanceSeats = new Map([]);

  static async getPerformances(showName) {
    let msg = {
      body: { }
    };
    if (showName !== undefined) {
      msg.body["show.name"] = showName;
    }
    return API.post("performance-query", "/", msg)
      .then(response => {
        return response.Response;
    }).catch(error => {
        console.log(error);
        return error;
    });
  }

  static async retrievePerformance(performanceRef) {
    const performanceKey = PerformanceCache.getMapKey(performanceRef);
    if (!PerformanceCache.performances.has(performanceKey)) {
      PerformanceCache.performances.set(performanceKey, PerformanceCache._retrievePerformance(performanceRef));
    }
    const performancePromise = PerformanceCache.performances.get(performanceKey);
    if (performancePromise.state === "pending")
      return performancePromise;
    else return Promise.resolve(performancePromise);
  }

  static async _retrievePerformance(performanceRef) {
    let body = {
      body: performanceRef
    };
    return API.post("performance-retrieve", "/", body)
      .then((response) => response.Response);
  }

  static async retrievePerformanceSeats(performanceRef) {
    const performanceKey = PerformanceCache.getMapKey(performanceRef);
    if (!PerformanceCache.performanceSeats.has(performanceKey)
      || Date.now() - Date.parse(PerformanceCache.performanceSeats["seat.state.timestamp"]) > 60000) {
      PerformanceCache.performanceSeats.set(performanceKey, PerformanceCache._retrievePerformanceSeats(performanceRef));
    }
    const performancePromise = PerformanceCache.performanceSeats.get(performanceKey);
    if (performancePromise.state === "pending")
      return performancePromise;
    else return Promise.resolve(performancePromise);
  }
  static async _retrievePerformanceSeats(performanceRef) {
    const body = {
      body: { "performance.ref": performanceRef }
    };
    return API.post("performance-seats-retrieve", "/", body)
      .then(response => response.Response);
  }

  static async retrieveNadheoPlaceSeats(performanceRef) {
    let performanceSeats = undefined;
    let refreshTime = undefined;
    let placeSeats = undefined;
    let placeSeatRows = undefined;
    let promise1 = PerformanceCache.retrievePerformanceSeats(performanceRef).then(object => {
      performanceSeats =
        object.seats.map((item)=>({"group.name": item.seat["seat.group.name"],
          "name": item.seat["seat.name"],
          "seat.category": item.seat["seat.category"],
          "status": item.seat.status}));
      refreshTime = object["seat.state.timestamp"]
    });
    let promise2 = PlaceCache.retrievePlaceSeats(performanceRef["place.name"]).then(object => {
      placeSeats = object.seats;
      placeSeatRows = object["seat.rows"];
    });
    await Promise.all([promise1, promise2]);
    return new NadheoPlaceSeats(placeSeats, placeSeatRows, performanceSeats, refreshTime);
  }

  /* Invalidate and reload a performance */
  static invalidate(performanceRef) {
    PerformanceCache.performanceSeats.delete(PerformanceCache.getMapKey(performanceRef));
    PerformanceCache.performances.delete(PerformanceCache.getMapKey(performanceRef));
    PerformanceCache.addCachedRequest(performanceRef);
  }


  static getMapKey(performanceRef) {
    return performanceRef["show.name"]+"|"+performanceRef["place.name"]+"|"+performanceRef["start.time"];
  }

  static cachedRequests = [];
  static addCachedRequest(performanceRef) {
    PerformanceCache.cachedRequests = PerformanceCache.cachedRequests.concat(performanceRef);
  }

  static executeOneCachedRequest() {
    if (PerformanceCache.cachedRequests.length === 0) return;
    const ref = PerformanceCache.cachedRequests.pop();
    PerformanceCache.retrievePerformance(ref).then((performance)=>{
      if (!performance["free.placement"]) {
        PerformanceCache.retrievePerformanceSeats(ref).then(() => {});
      }
    });
  }
}
setInterval((()=>{PerformanceCache.executeOneCachedRequest()}), 5000);

